import { Lazy } from "../lazy";
import { Logger } from "../../logger/logger";
import { UrlHelper } from "../html/url-helper";
import { DateHelper } from "../../helper/date-helper";

export class SessionStorageManager {
	public static getInstance: () => SessionStorageManager = Lazy.singleton(SessionStorageManager);
	private hasSessionStorage = true;
	public constructor() {
		if (!sessionStorage) {
			this.hasSessionStorage = false;
		}
	}

	public removeKey: (key: string) => void = (key) => {
		sessionStorage.removeItem(this.keyWithCacheId(key));
	}

	public hasKey: (key: string) => boolean = (key) => {
		if (!this.hasSessionStorage) {
			return false;
		}
		let result = sessionStorage.getItem(this.keyWithCacheId(key));
		return result == null;
	}

	public getKey: (key: string) => string = (key) => {
		return sessionStorage.getItem(this.keyWithCacheId(key));
	}

	public setKey: (key: string, data: string) => boolean = (key, data) => {
		if (!this.hasSessionStorage) {
			return false;
		}
		try {
			sessionStorage.setItem(this.keyWithCacheId(key), data);
		} catch (e) {
			Logger.error("Error while setting session storage", e)
		}

		return true;
	}

	public removeAll = (): void => {
		sessionStorage.clear();
	}

	public getSessionIdAndSetIfNecessary() {
		if (!this.hasSessionStorage) {
			return DateHelper.nowAsTicks();
		}
		let sessionId = window.sessionStorage.sessionId;

		if (!sessionId) {
			sessionId = window.sessionStorage.sessionId = DateHelper.nowAsTicks();
		} else {
			Logger.log({ sessionId });
		}

		return sessionId;
	}

	private keyWithCacheId(key: string) {
		return `${key}_${UrlHelper.getCacheId()}`;
	}
}